import script from "./AdminCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCategories.vue?vue&type=script&setup=true&lang=js"

import "./AdminCategories.vue?vue&type=style&index=0&id=98a56cba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98a56cba"]])

export default __exports__